var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('HomeSection'),_vm._v(" "),_c('WhyUseSection'),_vm._v(" "),_c('FeatureSection'),_vm._v(" "),_c('Screenshot'),_vm._v(" "),_c('DownloadSection'),_vm._v(" "),_c('ContactSection'),_vm._v(" "),_c('Copyright')],1)}
var staticRenderFns = []

export { render, staticRenderFns }